export class ReportType {
  public reportTitle: string;
  public active: boolean;
  constructor(data: any = {}) {
    this.reportTitle = data || "";
    this.active = false;
  }
}

export class projectList {
  public Project: string;
  public proj_plannedHour: string;
  public proj_businessUnit: string;
  public spentTotal: string;
  public createdDate: string;
  public startDate: string;
  public endDate: string;
  public originalstartDateobj: any = { formatted: "" };
  public originalendDateobj: any = { formatted: "" };
  public arrowclicked: boolean = false;
  public editMode: boolean = false;
  public empDetails: any;
  public projectID: any;
  public projectManager:any;
  public managerEmailID:any;
  public projectType:any;
  constructor(data: any) {
    this.Project = data.Project.Project ? data.Project.Project : "";
    this.projectType=data.Project.projectType?data.Project.projectType:"";
    this.proj_plannedHour = data.Project.plannedHour
      ? data.Project.plannedHour
      : "";
    this.proj_businessUnit = data.Project.businessUnit
      ? data.Project.businessUnit
      : "";
      this.projectManager=data.Project.projectManager?data.Project.projectManager:"";
      this.managerEmailID=data.Project.Manager_EmailID?data.Project.Manager_EmailID:"";
    this.projectID = data.Project.projectID ? data.Project.projectID : "";
    this.spentTotal = data.totalTimePerproject ? data.totalTimePerproject : "";
    this.startDate = data.Project.startDate
      ? data.Project.startDate.split("T")[0]
      : "";
    this.endDate = data.Project.endDate
      ? data.Project.endDate.split("T")[0]
      : "";
    this.originalstartDateobj.formatted = this.startDate ? this.startDate : "";
    this.originalendDateobj.formatted = this.endDate ? this.endDate : "";

    this.empDetails = data.empDetails;
  }
}

export class ExportData {
  public data: Array<any>;
  public fileName: string;
  public pageHeading: string;
  public flag: boolean;
  constructor(d: any = {}) {
    this.data = d.data || [];
    this.fileName = d.fileName || "";
    this.pageHeading = d.pageHeading || "";
    this.flag = d.flag || true;
  }
}

export class LockedList {
  public "Employee Name": string;
  public "Employee No": string;
  public "Email Id": string;
  public "RM Name": string;
  public "RM Code": string;
  public "Locked Date": string;
  constructor(data: any) {
    this["Employee Name"] = data.Empname ? data.Empname : "";
    this["Employee No"] = data.Empno_legacy ? data.Empno_legacy : "";
    this["Email Id"] = data.EmailID ? data.EmailID : "";
    this["RM Name"] = data.RMname ? data.RMname : "";
    this["RM Code"] = data.RMCode ? data.RMCode : "";
    if (
      data.Designation_Text ||
      data.Department_Text ||
      data.Cost_Center_Text
    ) {
      this["Designation Text"] = data.Designation_Text
        ? data.Designation_Text
        : "";
      this["Department Text"] = data.Department_Text
        ? data.Department_Text
        : "";
      this["Cost Center Text"] = data.Cost_Center_Text
        ? data.Cost_Center_Text
        : "";
    }
    this["Locked Date"] = data.lockedDetails.lockedDate
      ? new Date(data.lockedDetails.lockedDate).getDate() +
          "-" +
          (new Date(data.lockedDetails.lockedDate).getMonth() + 1) +
          "-" +
          new Date(data.lockedDetails.lockedDate).getFullYear() || ""
      : "";
  }
}

export class LockedListIPDOExport {
  public "Employee Name": string;
  public "Employee No": string;
  public "Email Id": string;
  public "RM Name": string;
  public "RM Code": string;
  public "Locked Date": string;
  public "Personnel Area": string;
  public "Personnel Sub Area": string;
  public "Team": string;
  public "Employee Sub Group": string;
  constructor(data: any, businessUnit) {
    this["Employee Name"] = data.Empname ? data.Empname : "";
    this["Employee No"] = data.Empno_legacy ? data.Empno_legacy : "";
    this["Email Id"] = data.EmailID ? data.EmailID : "";
    this["RM Name"] = data.RMname ? data.RMname : "";
    this["RM Code"] = data.RMCode ? data.RMCode : "";
    this["Personnel Area"] = data.Personnel_Area_Text
      ? data.Personnel_Area_Text
      : "";
    this["Personnel Sub Area"] = data.Personnel_Sub_Area_Text
      ? data.Personnel_Sub_Area_Text
      : "";
    this["Employee Sub Group"] = data.Employee_Sub_Group_Text
      ? data.Employee_Sub_Group_Text
      : "";
    if (businessUnit === "biologics") {
      delete this["Employee Sub Group"];
      this["Program Name"] = data.programName ? data.programName : "";
      this["Project Manager Name"] = data.projectManager
        ? data.projectManager
        : "";
      this["Position Description"] = data.positionDescription
        ? data.positionDescription
        : "";
      this["Employee L+1"] = data.RMname ? data.RMname : "";
      this["Cost Center"] = data.costCenterText ? data.costCenterText : "";
      this["Cost Center Text"] = data.costCenter ? data.costCenter : "";
      this["Department"] = data.department ? data.department : "";
      this["Level 3 Text"] = data.levelThree ? data.levelThree : "";
    }
    this["Team"] = data.Function_Code ? data.Function_Code : "";
    this["Locked Date"] = data.lockedDetails.lockedDate
      ? new Date(data.lockedDetails.lockedDate).getDate() +
          "-" +
          (new Date(data.lockedDetails.lockedDate).getMonth() + 1) +
          "-" +
          new Date(data.lockedDetails.lockedDate).getFullYear() || ""
      : "";
  }
}

export class PendingTimesheet {
  public selectedstartDate: string;
  public selectedendDate: string;
  public flag: number;
  public empno: number;
  public pageSize: number;
  public pageNumber: number;
  public reportExport: boolean;
  constructor(d: any = {}) {
    this.selectedendDate = d.selectedendDate || "";
    this.selectedstartDate = d.selectedstartDate || "";
    this.flag = d.flag || 0;
    this.empno = d.empno || null;
    this.pageSize = d.pageSize || null;
    this.pageNumber = d.pageNumber || null;
    this.reportExport = d.reportExport || false;
  }
}

export class EmployeeReportDeptWise {
  public selectedstartDate: string;
  public selectedendDate: string;
  public flag: number;
  public empno: number;
  public pageSize: number;
  public pageNumber: number;
  public reportExport: boolean;
  constructor(d: any = {}) {
    this.selectedendDate = d.selectedendDate || "";
    this.selectedstartDate = d.selectedstartDate || "";
    this.flag = d.flag || 0;
    this.empno = d.empno || null;
    this.pageSize = d.pageSize || null;
    this.pageNumber = d.pageNumber || null;
    this.reportExport = d.reportExport || false;
  }
}

// export class Timesheet {

//   public "Approval Status": string;
//   public "Email ID": string;
//   public "Employee Name": string;
//   public "Employee No": string;
//   public "Filled Hrs": any;
//   public "Leave Details": string;
//   public "Project Name": string;
//   public "Timesheet Date": any;
//   public "Submission Date":any;
//   public "Activity Name": string;
//   public "Business Unit": string;
//   public "Support Group": string;
//   public "Ticket No": string;
//   public "EmpDepartment":string;
//   public "Client":string;
//   public "ClientEmailID":string;

//   constructor(d: any = {}, flag: any) {
//     this["Employeee Name"] = d.empName || "";
//     this["Employee No"] = d.empno_legacy || "";
//     this["Email ID"] = d.emailID || "";
//     //this["Business Unit"] = d.businessUnit || "";
//     if (d.businessUnit === "accenture") {
//       this["Filled Hrs"] = parseFloat(d.filledHrs).toFixed(1) || "";
//     } else if (
//       d.businessUnit === "ipdo" ||
//       d.businessUnit === "biologics" ||
//       d.businessUnit === "chinateam" ||
//       d.businessUnit == "aps"
//     ) {

//       this["Project Manager"]=d.projectManager || "";
//       this["Filled Hrs"] = d.filledHrs || "";
//     }
//     this["Leave Details"] = d.leaveDetails || "";
//     this["EmpDepartment"]=d.EmpDepartment ||"";
//       this["Client"]=d.client ||"";
//       this["ClientEmailID"]=d.ClientEmailID || "";
//     this["Project Name"] = d.projectName || "";
//     this["Project Type"]=d.projectType||"";
//     if (flag === 0) {
//       this["Activity Name"] = d.activityName || "";
//       if (this["Business Unit"] === "accenture") {
//         this["Ticket No"] = d.ticketNumber || "";
//         this["Support Group"] = d.supportGroup || "";
//       }
//     } else if (flag === 1) {
//       delete this["Activity Name"];
//     }
//     this["Timesheet Date"] =
//       new Date(d.timesheetenteredDate).getDate() +
//         "-" +
//         (new Date(d.timesheetenteredDate).getMonth() + 1) +
//         "-" +
//         new Date(d.timesheetenteredDate).getFullYear() || "";

//     this["Submission Date"] =
//         new Date(d.timesheetSubmissionDate).getDate() +
//           "-" +
//           (new Date(d.timesheetSubmissionDate).getMonth() + 1) +
//           "-" +
//           new Date(d.timesheetSubmissionDate).getFullYear() || "";
//     this["Approval Status"] = d.approvalStatus || "";
//     if (
//       this["Business Unit"] === "ipdo" ||
//       d.businessUnit === "biologics" ||
//       d.businessUnit === "chinateam" ||
//       d.businessUnit == "aps"
//     ) {
//       delete this["Business Unit"];
//     }
//   }
// }


export class Timesheet {
  public "Employee Name": string;
  public "Employee No": string;
  public "Email ID": string;
  public "Project Manager": string;
  public "Filled Hrs": any;
  public "Leave Details": string;
  public "EmpDepartment": string;
  public "Client": string;
  public "ClientEmailID": string;
  public "Project Name": string;
  public "Project Type": string;
  public "Activity Name": string;
  public "Timesheet Date": string;
  public "Submission Date": string;
  public "Approval Status": string;
  public "Business Unit": string;
  public "Support Group": string;
  public "Ticket No": string;

  constructor(d: any = {}, flag: number = 0) {
    // Define all fields in required order
    const orderedFields = [
      "Employee Name",
      "Employee No",
      "Email ID",
      "Project Manager",
      "Filled Hrs",
      "Leave Details",
      "EmpDepartment",
      "Client",
      "ClientEmailID",
      "Project Name",
      "Project Type",
      "Activity Name",
      "Timesheet Date",
      "Submission Date",
      "Approval Status"
    ];

    // Initialize everything to empty string
    orderedFields.forEach(field => (this[field] = ""));

    // Now populate from data safely
    this["Employee Name"] = d.empName || "";
    this["Employee No"] = d.empno_legacy || "";
    this["Email ID"] = d.emailID || "";
    this["Project Manager"] = d.projectManager || "";

    if (d.businessUnit === "accenture") {
      this["Filled Hrs"] = d.filledHrs
        ? parseFloat(d.filledHrs).toFixed(1)
        : "";
    } else {
      this["Filled Hrs"] = d.filledHrs || "";
    }

    this["Leave Details"] = d.leaveDetails || "";
    this["EmpDepartment"] = d.EmpDepartment || "";
    this["Client"] = d.client || "";
    this["ClientEmailID"] = d.ClientEmailID || "";
    this["Project Name"] = d.projectName || "";
    this["Project Type"] = d.projectType || "";

    // Activity Name based on flag
    if (flag === 0) {
      this["Activity Name"] = d.activityName || "";
    }

    // Handle dates safely
    const tsDate = d.timesheetenteredDate
      ? new Date(d.timesheetenteredDate)
      : null;
    const subDate = d.timesheetSubmissionDate
      ? new Date(d.timesheetSubmissionDate)
      : null;

    this["Timesheet Date"] = tsDate
      ? `${tsDate.getDate()}-${tsDate.getMonth() + 1}-${tsDate.getFullYear()}`
      : "";
    this["Submission Date"] = subDate
      ? `${subDate.getDate()}-${subDate.getMonth() + 1}-${subDate.getFullYear()}`
      : "";

    this["Approval Status"] = d.approvalStatus || "";
  }
}

// export class ExportIpdoDetailedView {
//   public "Approval Status": string;
//   public "Email ID": string;
//   public "Employee Name": string;
//   public "Employee No": string;
//   public "Filled Hrs": number;
//   public "Leave Details": string;
//   public "Project Name": string;
//   public "Timesheet Date": any;
//   public "Activity Name": string;
//   public "Business Unit": string;
//   public "Emp Status": string;
//   public "Personnel Area": string;
//   public "Personnel Sub Area": string;
//   public "Employee Sub Group": string;
//   public "Team": string;
//   public "EmpDepartment":string;
//   public "Client":string;
//   public "ClientEmailID":string;

//   constructor(d: any = {}, flag: any) {
//     this["Employee Name"] = d.empName || "";
//     this["Employee No"] = d.empno_legacy || "";
//     this["Email ID"] = d.emailID || "";
//     this["Business Unit"] = d.businessUnit || "";
//     this["EmpDepartment"]=d.EmpDepartment ||"";
//     this["Client"]=d.client ||"";
//     this["ClientEmailID"]=d.ClientEmailID || "";
//     this["Project Manager"]=d.projectManager || ""
//     this["Filled Hrs"] = d.filledHrs || "";
//     this["Leave Details"] = d.leaveDetails || "";
//     this["Project Name"] = d.projectName || "";
//     this["Emp Status"] = d.employeeStatus || "";
//     //this["Personnel Area"] = d.personnelArea || "";
//     //this["Personnel Sub Area"] = d.personnelSubarea || "";
//     //this["Employee Sub Group"] = d.employeeSubgroup || "";
//     //this["Team"] = d.Team ? d.Team : "";

//     if (flag === 0) {
//       this["Activity Name"] = d.activityName || "";
//     } else if (flag === 1) {
//       delete this["Activity Name"];
//     }

//     this["Timesheet Date"] =
//       new Date(d.timesheetenteredDate).getDate() +
//         "-" +
//         (new Date(d.timesheetenteredDate).getMonth() + 1) +
//         "-" +
//         new Date(d.timesheetenteredDate).getFullYear() || "";
//     this["Approval Status"] = d.approvalStatus || "";
//     if (
//       this["Business Unit"] == "ipdo" ||
//       d.businessUnit === "biologics" ||
//       d.businessUnit === "chinateam" ||
//       d.businessUnit == "aps"
//     ) {
//       delete this["Business Unit"];
//     }
//   }
// }

export class ExportIpdoDetailedView {
  public "Employee Name": string;
  public "Employee No": string;
  public "Email ID": string;
  public "Project Manager": string;
  public "Filled Hrs": string;
  public "Leave Details": string;
  public "EmpDepartment": string;
  public "Client": string;
  public "ClientEmailID": string;
  public "Project Name": string;
  public "Project Type": string;
  public "Activity Name": string;
  public "Timesheet Date": string;
  public "Submission Date": string;
  public "Approval Status": string;
  public "Emp Status": string;

  constructor(d: any = {}, flag: number = 0) {
    // Define required fields in exact order
    const orderedFields = [
      "Employee Name",
      "Employee No",
      "Email ID",
      "Project Manager",
      "Filled Hrs",
      "Leave Details",
      "EmpDepartment",
      "Client",
      "ClientEmailID",
      "Project Name",
      "Project Type",
      "Activity Name",
      "Timesheet Date",
      "Submission Date",
      "Approval Status",
      "Emp Status"
    ];

    // Initialize all fields as empty strings
    orderedFields.forEach(field => (this[field] = ""));

    // Populate data safely
    this["Employee Name"] = d.empName || "";
    this["Employee No"] = d.empno_legacy || "";
    this["Email ID"] = d.emailID || "";
    this["Project Manager"] = d.projectManager || "";
    this["Filled Hrs"] = d.filledHrs ? d.filledHrs.toString() : "";
    this["Leave Details"] = d.leaveDetails || "";
    this["EmpDepartment"] = d.EmpDepartment || "";
    this["Client"] = d.client || "";
    this["ClientEmailID"] = d.ClientEmailID || "";
    this["Project Name"] = d.projectName || "";
    this["Project Type"] = d.projectType || "";

    // Conditional Activity Name (based on flag)
    this["Activity Name"] = flag === 0 ? (d.activityName || "") : "";

    // Handle and format dates safely
    const tsDate = d.timesheetenteredDate ? new Date(d.timesheetenteredDate) : null;
    const subDate = d.timesheetSubmissionDate ? new Date(d.timesheetSubmissionDate) : null;

    this["Timesheet Date"] = tsDate
      ? `${String(tsDate.getDate()).padStart(2, "0")}-${String(tsDate.getMonth() + 1).padStart(2, "0")}-${tsDate.getFullYear()}`
      : "";
    this["Submission Date"] = subDate
      ? `${String(subDate.getDate()).padStart(2, "0")}-${String(subDate.getMonth() + 1).padStart(2, "0")}-${subDate.getFullYear()}`
      : "";

    this["Approval Status"] = d.approvalStatus || "";
    this["Emp Status"] = d.employeeStatus || "";
  }
}


export class EmployeeReport {
  public "Sl No": number;
  public "Project Name": string;
  public "Time Spent": string;
  constructor(d: any = {}, ind) {
    this["Sl No"] = ind + 1 || null;
    this["Project_Name"] = d.projectname || "";
    this["Time Spent"] = d.totalHrs || null;
  }
}

export class ProjectExport {
  public "Sl No": number;
  public "Project Name": string;
  public "Project PlannedHrs": string;
  // public "Project Businessunit": string;
  public "Employee Name": string;
  public "Employee No": string;
  public "Email ID": string;
  public "Time Spent": number;
  public "projectType":any;
  constructor(d: any = {}, p: any, indx, bu) {
    this["Sl No"] = indx + 1 || null;
    this["Project Name"] = p.Project ? p.Project : "";
    this["projectType"]=p.projectType?p.projectType:"";
    this["Project PlannedHrs"] = p.proj_plannedHour ? p.proj_plannedHour : "";
    // this["Project Businessunit"] = p.proj_businessUnit
    //   ? p.proj_businessUnit
    //   : "";
    this["Employee Name"] = d.empdetails.Empname || "";
    this["Employee No"] = d.empdetails.Empno_legacy || null;
    this["Email ID"] = d.empdetails.EmailID || "";
    if (
      bu === "ipdo" ||
      bu === "biologics" ||
      bu === "chinateam" ||
      bu === "aps"
    ) {
      this["Time Spent"] = d.spentHrs || "00:00";
    }
    if (bu === "biologics") {
      this["Program Name"] = d.empdetails.programName
        ? d.empdetails.programName
        : "NA";
      this["Project Manager Name"] = d.empdetails.projectManager
        ? d.empdetails.projectManager
        : "NA";
    }
    if (bu === "accenture") {
      this["Time Spent"] = d.spentHrs.toFixed(1) || 0;
    }
  }
}

export class ProjectIPDOExport {
  public "Sl No": number;
  public "Project Name": string;
  public "Project PlannedHrs": string;
  public "Project Businessunit": string;
  public "Employee Count": number;
  public "Employee Name": string;
  public "Employee No": string;
  public "Time Spent": number;
  public "Email ID": string;
  public "Personnel Area": string;
  public "Personnel Sub Area": string;
  public "Employee Sub Group": string;
  public "spentTotal": string;
  public "projectType":any;

  constructor(d: any = {}, p: any, indx, businessUnit) {
    this["Sl No"] = indx + 1 || null;
    this["Project Name"] = p.Project ? p.Project : "";
    this["projectType"]=p.projectType?p.projectType:"";
    this["Project Manager"]=p.projectManager ? p.projectManager:"";
    this["Manager EmailID"]=p.managerEmailID ? p.managerEmailID:"";
    this["Project PlannedHrs"] = p.proj_plannedHour ? p.proj_plannedHour : "";
    this["Project Businessunit"] = p.proj_businessUnit
      ? p.proj_businessUnit
      : "";
    this["spentTotal"] = p.spentTotal ? p.spentTotal : "";
    this["Employee Count"] = p.empDetails.length || 0;
    this["Employee Name"] = d.empdetails.Empname || "";
    this["Employee No"] = d.empdetails.Empno_legacy || "";
    this["Email ID"] = d.empdetails.EmailID || "";
    //this["Personnel Area"] = d.empdetails.Personnel_Area_Text || "";
    //this["Personnel Sub Area"] = d.empdetails.Personnel_Sub_Area_Text || "";
    //this["Employee Sub Group"] = d.empdetails.Employee_Sub_Group_Text || "";

    // if (businessUnit === "biologics") {
    //   delete this["Employee Sub Group"];
    //   this["Program Name"] = d.empdetails.programName
    //     ? d.empdetails.programName
    //     : "";
    //   this["Project Manager Name"] = d.empdetails.projectManager
    //     ? d.empdetails.projectManager
    //     : "";
    //   this["Position Description"] = d.empdetails.positionDescription
    //     ? d.empdetails.positionDescription
    //     : "";
    //   this["Employee L+1"] = d.empdetails.RMname ? d.empdetails.RMname : "";
    //   this["Cost Center"] = d.empdetails.costCenterText
    //     ? d.empdetails.costCenterText
    //     : "";
    //   this["Cost Center Text"] = d.empdetails.costCenter
    //     ? d.empdetails.costCenter
    //     : "";
    //   this["Department"] = d.empdetails.department
    //     ? d.empdetails.department
    //     : "";
    //   this["Level 3 Text"] = d.empdetails.levelThree
    //     ? d.empdetails.levelThree
    //     : "";
    // }
    this["Time Spent"] = d.spentHrs || "00:00";
  }
}

export class RmReport {
  public "Sl No": number;
  public "Employee": string;
  public "Emloyee No": number;
  public "Time Spent": number;
  constructor(d: any = {}, indx) {
    this["Sl No"] = indx + 1 || null;
    this["Employee"] = d.Empname || "";
    this["Emloyee No"] = d.Empno || null;
    this["Time Spent"] = d.spentHrs || null;
  }
}

export class UtilizationReport {
  public "Employee": string;
  public "Employee No": string;
  public "Email Id": string;
  public "Time Spent": any;
  constructor(d: any = {}, businessUnit) {
    this["Employee"] = d._id.empname || "";
    this["Employee No"] = d._id.userDetails.Empno_legacy || null;
    this["Email Id"] = d._id.emailID || "";
    if (
      businessUnit === "ipdo" ||
      businessUnit === "biologics" ||
      businessUnit === "chinateam" ||
      businessUnit == "aps"
    ) {
      this["Time Spent"] = d.totalhrs || "00:00";
    } else if (businessUnit === "accenture") {
      this["Time Spent"] = d.totalhrs.toFixed(1) || 0;
    }
  }
}

export class UtilizationIPDOReport {
  public "Employee": string;
  public "Employee No": string;
  public "Email Id": string;
  public "Time Spent": any;
  public "Personnel Area": string;
  public "Personnel Sub Area": string;
  public "Employee Sub Group": string;
  public "Team": string;

  constructor(d: any = {}, businessUnit) {
    this["Employee"] = d._id.empname || "";
    this["Employee No"] = d._id.userDetails.Empno_legacy || null;
    this["Email Id"] = d._id.emailID || "";
    // this["Personnel Area"] = d._id.userDetails.Personnel_Area_Text || "";
    // this["Personnel Sub Area"] =
    //   d._id.userDetails.Personnel_Sub_Area_Text || "";
    // this["Team"] = d._id.userDetails.Function_Code || "";
    // this["Employee Sub Group"] =
    //   d._id.userDetails.Employee_Sub_Group_Text || "";
    // if (businessUnit === "biologics") {
    //   delete this["Employee Sub Group"];
    //   this["Program Name"] = d.userDetails.programName
    //     ? d.userDetails.programName
    //     : "";
    //   this["Project Manager Name"] = d.userDetails.projectManager
    //     ? d.userDetails.projectManager
    //     : "";
    //   this["Position Description"] = d.userDetails.positionDescription
    //     ? d.userDetails.positionDescription
    //     : "";
    //   this["Employee L+1"] = d.userDetails.RMname ? d.userDetails.RMname : "";
    //   this["Cost Center"] = d.userDetails.costCenterText
    //     ? d.userDetails.costCenterText
    //     : "";
    //   this["Cost Center Text"] = d.userDetails.costCenter
    //     ? d.userDetails.costCenter
    //     : "";
    //   this["Department"] = d.userDetails.department
    //     ? d.userDetails.department
    //     : "";
    //   this["Level 3 Text"] = d.userDetails.levelThree
    //     ? d.userDetails.levelThree
    //     : "";
    // }
    if (
      businessUnit === "ipdo" ||
      businessUnit === "biologics" ||
      businessUnit === "chinateam" ||
      businessUnit === "aps"
    ) {
      this["Time Spent"] = d.totalhrs || "00:00";
    } else if (businessUnit === "accenture") {
      this["Time Spent"] = d.totalhrs || 0;
    }
  }
}

export class UtilizationTimesheet {
  public startDate: string;
  public endDate: string;
  public pageSize: number;
  public pageNumber: number;
  public reportExport: boolean;
  constructor(d: any = {}) {
    this.startDate = d.week || "";
    this.endDate = d.date || "";
    this.pageNumber = this.pageNumber || null;
    this.pageSize = this.pageSize || null;
    this.reportExport = this.reportExport || false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/reports/report.ts